import React from "react";
import { Link } from "react-router-dom";

import { getListGroupsFAQ } from "../../model/common";

import { commonErr } from "../common/errors";
import { formatTitleGroupName } from "../common/common";

import Header from "../components/header";
import Footer from "../components/footer";
import FaqBottom from "./components/faqbottom";
import { LoadingInline } from "../common/loading";

const viewModes = {
	OWNER: 1,
	TRAVELER: 2,
};

const ListGroupItem = ({ err, groups, isMobile, isRenter }) => {
	var content;
	if (err !== commonErr.SUCCESS) {
		content = <LoadingInline />;
	} else {
		content = (
			<div className="category-body">
				{groups &&
					groups.map((item) => (
						<Link
							to={`/faq/${formatTitleGroupName(item.name)}/${item.id}${isMobile ? "/mobile" : ""}${
								isRenter ? "/renter" : ""
							}`}
							key={item.id}
							className="category-item">
							<img loading="lazy" src={item.iconUrl} />
							<h6>{item.name}</h6>
							<p>{item.desc}</p>
						</Link>
					))}
			</div>
		);
	}
	return <>{content}</>;
};

class TabMode extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			handler: props.handler,
		};
	}

	static getDerivedStateFromProps(nextProps, prevState) {
		if (nextProps.handler !== prevState.handler) {
			return { handler: nextProps.handler };
		} else return null;
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevState.handler !== this.state.handler) {
			this.props.setView(this.state.handler);
		}
	}

	render() {
		const { handler } = this.state;
		const { isRenter } = this.props;
		return (
			<div className="category-head">
				<div className="category-option">
					<h4>Danh mục</h4>
					{!isRenter && (
						<div className="category-type">
							<a href="#owner" className={`btn btn-type ${handler === "#owner" ? "active" : ""}`}>
								Chủ xe
							</a>
							<a
								href="#traveler"
								className={`btn btn-type ${handler === "#traveler" || handler === "" ? "active" : ""}`}>
								Khách thuê xe
							</a>
						</div>
					)}
				</div>
			</div>
		);
	}
}

class Faqs extends React.Component {
	constructor() {
		super();

		this.state = {
			err: commonErr.INNIT,
			errMsg: "",
			isMobile: false,
			isRenter: false,
		};
	}

	componentDidMount() {
		window.scrollTo(0, 0);

		const isMobile = this.props.location.pathname.includes("/mobile");
		const isRenter = this.props.location.pathname.includes("/renter");
		let handler = this.props.location.hash;
		if (handler === "") {
			handler = "#traveler";
		}
		if (isRenter) {
			handler = "#traveler";
		}
		this.setState({
			isMobile: isMobile,
			isRenter: isRenter,
		});
		this.setView(handler);
	}

	getListGroupsFAQ = (mode) => {
		this.setState({
			err: commonErr.LOADING,
		});
		getListGroupsFAQ(mode).then((resp) => {
			if (resp.data.error >= commonErr.SUCCESS && resp.data.data.groups) {
				this.setState({
					err: resp.data.error,
					groups: resp.data.data.groups,
				});
			} else {
				this.setState({
					err: resp.data.error,
					errMsg: resp.data.errorMessage,
				});
			}
		});
	};

	setView = (handler) => {
		let mode;
		switch (handler) {
			case "#owner":
				mode = viewModes.OWNER;
				break;
			case "#traveler":
				mode = viewModes.TRAVELER;
				break;
			default:
				mode = viewModes.TRAVELER;
		}
		this.getListGroupsFAQ(mode);
	};

	render() {
		const { err, groups, isMobile, isRenter } = this.state;
		let handler = this.props.location.hash;

		if (isRenter) {
			handler = "#traveler";
		}

		return (
			<div className="mioto-layout">
				{!isMobile && !isRenter && <Header />}
				<section className="body">
					<div className="faqs-page" id={handler === "#owner" ? "owner" : "traveler"}>
						<div className="faqs-category space sec">
							<div className="m-container">
								<TabMode handler={handler} isRenter={isRenter} setView={() => this.setView(handler)} />
								<ListGroupItem err={err} groups={groups} isRenter={isRenter} isMobile={isMobile} handler={handler} />
							</div>
						</div>
						<FaqBottom />
					</div>
				</section>
				{!isMobile && !isRenter && <Footer />}
			</div>
		);
	}
}

export default Faqs;
